import React from "react";
import { HeaderModule } from '../../../components/home/HeaderModule';
import { HubOutlined } from "@mui/icons-material";
import { ActionsBar } from "../../../components/ActionsBar";
import { TableModule } from "../../../components/home/TableModule";
import { useChannels } from "../../../hooks/encuestas/useChannels";

export const Channels = () => {

    const { columns, channels, addChannel, searchChannel } = useChannels();

    return (
        <>
            <HeaderModule 
                icon={ <HubOutlined htmlColor="rgba(0, 0, 0, .6)" /> }
                title='Canales'
            />

            <ActionsBar 
                addAction={ addChannel } 
                module='canales' 
                searchAction={ searchChannel } 
                searchPlaceholder='Canal'
            />

            <TableModule
                columns={ columns }
                rows={ channels }
                styles={{
                    background: '#fff',
                    borderRadius: 6,
                    marginTop: 10,
                }}
            />
        </>
    )
};